import type { PlatformSaleItemEntity } from '~/types/sale.type';

type UseTrustReportReturn = {
    isTrustReportEligible: ComputedRef<boolean>;
};

export const useTrustReport = (sale: MaybeRefOrGetter<Pick<PlatformSaleItemEntity, 'type'>>): UseTrustReportReturn => {
    const { isToBeScraped } = useSaleType(() => toValue(sale).type);

    return {
        isTrustReportEligible: computed(() => !isToBeScraped.value),
    };
};
